<div *transloco="let t; prefix: 'property-listing.surroundings'" [formGroup]="surroundingsFormGroup" class="flex-1">
  <div class="flex flex-col rfs:gap-[72px]">
    <div class="flex flex-col gap-6">
      <h2 class="h2 text-black">{{ 'property-listing.tabs.settingAndSurroundings' | transloco }}</h2>
    </div>

    <div class="flex flex-col">
      <h3 class="h3 text-black mb-6">{{ t('subheaders.settings') }}</h3>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('labels.view') }}
      </div>
      <div class="flex flex-row flex-wrap gap-4 mb-6">
        <label *ngFor="let viewEnum of view | keyvalue: unsorted" [attr.for]="'view'+viewEnum.key"
          class="visual-checkbox flex flex-col">
          <input (click)="onMultipleCheckboxClick(viewEnum.key, surroundingsFormGroup.controls.view)"
            [attr.id]="'view'+viewEnum.key" [attr.name]="'checkbox-selector-view'+viewEnum.key"
            [checked]="surroundingsFormGroup.controls.view.value.indexOf(viewEnum.key) > -1"
            class="opacity-0 absolute h-0 w-0" type="checkbox">
          <span class="">{{ 'shared.enum.view.' + viewEnum.key | transloco }}</span>
        </label>
      </div>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('labels.orientation') }}
      </div>
      <div class="flex flex-row flex-wrap gap-4 mb-16">
        <label *ngFor="let orientationEnum of orientation | keyvalue: unsorted"
          [attr.for]="'radio-selector-orientation'+orientationEnum.key" class="visual-checkbox flex flex-col">
          <input
            (click)="surroundingsFormGroup.controls.orientation.setValue(surroundingsFormGroup.controls.orientation.value === orientationEnum.key ? null : orientationEnum.key)"
            [attr.id]="'radio-selector-orientation'+orientationEnum.key"
            [checked]="surroundingsFormGroup.controls.orientation.value === orientationEnum.value"
            class="opacity-0 absolute h-0 w-0" type="radio">
          <span class="">{{ 'shared.enum.orientation.' + orientationEnum.key | transloco }}</span>
        </label>
      </div>

      <h3 class="h3 text-black mb-6">{{ t('subheaders.surroundings') }}</h3>
      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('helperText.surroundings') }}
      </div>
      <div class="flex flex-row flex-wrap gap-4 mb-6">
        <label *ngFor="let surroundingEnum of surrounding | keyvalue: unsorted"
          [attr.for]="'surrounding'+surroundingEnum.key" class="visual-checkbox flex flex-col">
          <input (click)="onMultipleCheckboxClick(surroundingEnum.key, surroundingsFormGroup.controls.surrounding)"
            [attr.id]="'surrounding'+surroundingEnum.key"
            [attr.name]="'checkbox-selector-surrounding'+surroundingEnum.key"
            [checked]="surroundingsFormGroup.controls.surrounding.value.indexOf(surroundingEnum.key) > -1"
            [value]="surroundingEnum.value" class="opacity-0 absolute h-0 w-0" type="checkbox">
          <span class="">{{ 'shared.enum.surrounding.' + surroundingEnum.key | transloco }}</span>
        </label>
      </div>

      <div class="mb-6">
        <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
          {{ t('labels.nearbyHighways') }}
        </div>
        <div class="flex flex-col gap-1">
          <input [formControl]="highway" [placeholder]="t('placeholders.nearbyHighways')"
            class="bg-white text-black rounded-full py-[10px] px-6 w-full" type="text">
          <button class="px-5 py-3 h-11 gap-2 rounded-full flex flex-row items-center group" (click)="onAddHighway()">
            <div class="w-5 h-5 relative">
              <i style="color: #007c55;" class="icon-plus  text-sm"></i>
            </div>
            <div style="color: #007c55;" class="text-center text-sm">{{t('addAvenue')}}</div>
          </button>
          @if (currentLang === 'el') {
          <div *ngFor="let highwayEl of nearbyHighwaysEl.value"
            class="bg-white hover:bg-white/40 rounded-full py-[10px] px-6 text-black flex justify-between">
            {{ highwayEl }}
            <i (click)="onHighwayRemove(highwayEl, nearbyHighwaysEl)" class="icon-trash cursor-pointer"></i>
          </div>
          } @else if (currentLang === 'en') {
          <div *ngFor="let highwayEn of nearbyHighwaysEn.value"
            class="bg-white hover:bg-white/40 rounded-full py-[10px] px-6 text-black flex justify-between">
            {{ highwayEn }}
            <i (click)="onHighwayRemove(highwayEn, nearbyHighwaysEn)" class="icon-trash cursor-pointer"></i>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>